export const delayLongPress = 2000
export const initialRequestDelay = 3000
export const frequentCallDelay = 200